/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_In_TransitInputs */

const en_metric_in_transit = /** @type {(inputs: Metric_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Transit`)
};

const es_metric_in_transit = /** @type {(inputs: Metric_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En transito`)
};

/**
* | output |
* | --- |
* | "In Transit" |
*
* @param {Metric_In_TransitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_in_transit = /** @type {((inputs?: Metric_In_TransitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_In_TransitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_in_transit(inputs)
	return es_metric_in_transit(inputs)
});